// extracted by mini-css-extract-plugin
module.exports = {"expertDataServices":"_1lr9x","title":"_2seHf","servicesContainer":"_34x8K","innerServiceSectionContainer":"D8QOL","first":"_2La0E","last":"_2XEtS"};